import { fivedigit } from './utils.js';
import { getDatesBetween } from './calendar.js';
export function setAllHoverTemplates(sbplot, newTemplate) {
        var newTemplates = new Array(sbplot.data.length).fill(newTemplate);
        Plotly.restyle(sbplot, { 'hovertemplate': newTemplates });
}

export function restoreAllOriginalTemplates(sbplot, originalHoverTemplates) {
        Plotly.restyle(sbplot, { 'hovertemplate': originalHoverTemplates });
}
export function create_dataexplorer_graph(hdata, hdata_base, vdata, vdata_base, graph_name) {


	var fig_graphline = {
		x: hdata,
		x_base: hdata_base,
		y: vdata,
		y_source: vdata_base,
		name: graph_name,
		row: 1,
		col: 1,
		type: 'scatter',
		mode: 'lines+markers',
		line: {
			width: 1.5,
			shape: 'spline',
			smoothing: 1.3
		},
	}


	const config = {
		displayModeBar: false,
		responsive: true,
		modeBarButtonsToRemove: ['toImage', 'sendDataToCloud', 'hoverCompareCartesian'],
	};


	var layout = {
		dragmode: false,
		xaxis: {

		},
		yaxis: {

		},
		name: graph_name,
		autosize: true,
		margin: {
		},
		plot_bgcolor: 'white',
	};

	const figure = { data: [fig_graphline], layout: layout, config: config };

	return figure
}



export function draw_date_row_events(graphdata, includeclusters, flipdirection) {



	//var trace1 = graphdata["data"][2]

	var trace1 = graphdata["data"][0]


	var all_y_len = trace1['y'].length;
	var new_y_date_data = Array(all_y_len).fill(0);

	const first_date = new Date(trace1['x'].at(0));
	const last_date = new Date(trace1['x'].at(-1));


	//console.log("date range: ", first_date, last_date)

	const date_list = getDatesBetween(first_date, last_date);


	var fig_dateline = {
		x: trace1['x'],
		y: new_y_date_data,
		row: 1,
		col: 1,
		type: 'bar'
	}


	const config = {
		displayModeBar: false,
		responsive: true,
		modeBarButtonsToRemove: ['toImage', 'sendDataToCloud', 'hoverCompareCartesian'],
	};





	let drawside = "top"
	let margin_t = 20
	let margin_b = 0

	let date_height = 42
	if (!flipdirection) {
		drawside = "bottom"
		margin_t = 0
		margin_b = 20
		date_height = 26
	}


	var layout = {
		height: date_height,
		dragmode: false,
		xaxis: {
			zeroline: true,
			showline: true,
			showgrid: true,
			showticklabels: true,
			linecolor: "rgb(204, 204, 204)",
			linewidth: 2,
			tickformat: "%b %d",
			ticklen: 6,
			ticks: "inside",
			tickmode: "array",
			tickvals: date_list,
			ticklabeloverflow: "hide past div",
			tickfont: {
				family: "Courier New, monospace",
				size: 14
			},
			side: drawside
		},
		yaxis: {
			zeroline: false,
			showline: false,
			showgrid: false,
			showticklabels: false,
		},
		autosize: true,
		margin: {
			autoexpand: false,
			r: 0,
			l: 34,
			t: margin_t,
			b: margin_b
		},
		showlegend: false,
		plot_bgcolor: 'white',
	};


	if (includeclusters) {

		let clusterdata = document.getElementById("event_clusterdata").value;

		var annotations = [];

		if (clusterdata) {
			clusterdata = JSON.parse(clusterdata);
			var total_clusters = clusterdata.length;
			var arrow_size = '18'
			var down_arrow = '&#9660'
			var down_arrow_start_text = "<span style='font-size:" + arrow_size + "px;color:green;'>" + down_arrow + ";</span>"
			var down_arrow_end_text = "<span style='font-size:" + arrow_size + "px;color:red;'>" + down_arrow + ";</span>"

			for (let x = 0; x < total_clusters; x++) {

				var start_cluster = clusterdata[x]["ts_start"];
				var end_cluster = clusterdata[x]["ts_end"];
				start_cluster = moment(start_cluster);
				start_cluster = start_cluster.subtract(1, 'hour');
				start_cluster_str = start_cluster.format('YYYY-MM-DD HH:mm:ss');
				end_cluster = moment(end_cluster);
				end_cluster = end_cluster.add(1, 'hour');
				end_cluster_str = end_cluster.format('YYYY-MM-DD HH:mm:ss');

				start_annotation = {
					x: start_cluster_str,
					y: 10,
					xref: "x",
					yref: "y",
					text: down_arrow_start_text,
					showarrow: false
				}

				end_annotation = {
					x: end_cluster_str,
					y: 10,
					xref: "x",
					yref: "y",
					text: down_arrow_end_text,
					showarrow: false
				}
				annotations.push(start_annotation)
				annotations.push(end_annotation)


			}


		}

		if (annotations) {
			layout["annotations"] = annotations
		}

	}





	const figure = { data: [fig_dateline], layout: layout, config: config };
	const graphid = "swanbot_graph_" + fivedigit();
	swanbot_dataexplorer_date_graph_id = graphid;

	return [graphid, figure]


}


export function draw_date_row(graphdata, includeclusters, flipdirection) {


	//console.log("draw_date_row graphdata", graphdata)
	//var trace1 = graphdatanew_y_date_data["data"][2]

	var trace1 = graphdata; //graphdata["data"][0]


	var all_y_len = graphdata.length;
	var new_y_date_data = Array(all_y_len).fill(0);

	const first_date = new Date(graphdata.at(0));
	const last_date = new Date(graphdata.at(-1));


	//console.log("date range: ", first_date, last_date)

	const date_list = getDatesBetween(first_date, last_date);


	var fig_dateline = {
		x: graphdata,
		y: new_y_date_data,
		row: 1,
		col: 1,
		type: 'bar'
	}


	const config = {
		displayModeBar: false,
		responsive: true,
		modeBarButtonsToRemove: ['toImage', 'sendDataToCloud', 'hoverCompareCartesian'],
	};





	let drawside = "top"
	let margin_t = 20
	let margin_b = 0

	let date_height = 42
	if (!flipdirection) {
		drawside = "bottom"
		margin_t = 0
		margin_b = 20
		date_height = 26
	}


	var layout = {
		height: date_height,
		dragmode: false,
		xaxis: {
			zeroline: true,
			showline: true,
			showgrid: true,
			showticklabels: true,
			linecolor: "rgb(204, 204, 204)",
			linewidth: 2,
			tickformat: "%b %d",
			ticklen: 6,
			ticks: "inside",
			tickmode: "array",
			tickvals: date_list,
			ticklabeloverflow: "hide past div",
			tickfont: {
				family: "Courier New, monospace",
				size: 14
			},
			side: drawside
		},
		yaxis: {
			zeroline: false,
			showline: false,
			showgrid: false,
			showticklabels: false,
		},
		autosize: true,
		margin: {
			autoexpand: false,
			r: 0,
			l: 34,
			t: margin_t,
			b: margin_b
		},
		showlegend: false,
		plot_bgcolor: 'white',
	};


	if (includeclusters) {

		let clusterdata = document.getElementById("event_clusterdata").value;

		var annotations = [];

		if (clusterdata) {
			clusterdata = JSON.parse(clusterdata);
			var total_clusters = clusterdata.length;
			var arrow_size = '18'
			var down_arrow = '&#9660'
			var down_arrow_start_text = "<span style='font-size:" + arrow_size + "px;color:green;'>" + down_arrow + ";</span>"
			var down_arrow_end_text = "<span style='font-size:" + arrow_size + "px;color:red;'>" + down_arrow + ";</span>"

			for (let x = 0; x < total_clusters; x++) {

				var start_cluster = clusterdata[x]["ts_start"];
				var end_cluster = clusterdata[x]["ts_end"];
				start_cluster = moment(start_cluster);
				start_cluster = start_cluster.subtract(1, 'hour');
				start_cluster_str = start_cluster.format('YYYY-MM-DD HH:mm:ss');
				end_cluster = moment(end_cluster);
				end_cluster = end_cluster.add(1, 'hour');
				end_cluster_str = end_cluster.format('YYYY-MM-DD HH:mm:ss');

				start_annotation = {
					x: start_cluster_str,
					y: 10,
					xref: "x",
					yref: "y",
					text: down_arrow_start_text,
					showarrow: false
				}

				end_annotation = {
					x: end_cluster_str,
					y: 10,
					xref: "x",
					yref: "y",
					text: down_arrow_end_text,
					showarrow: false
				}
				annotations.push(start_annotation)
				annotations.push(end_annotation)


			}


		}

		if (annotations) {
			layout["annotations"] = annotations
		}

	}





	const figure = { data: [fig_dateline], layout: layout, config: config };
	const graphid = "swanbot_graph_" + fivedigit();
	swanbot_dataexplorer_date_graph_id = graphid;

	return [graphid, figure]


}
